import { atom } from "jotai";
import { UserFilter } from "../types";

export const UserFiltersAtom = atom<UserFilter[]>([]);
